export default __webpack_public_path__ + "static/media/Industry.72a3645a.png";